import { Stack } from '@atgfr8/atg-ui-tailwind';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { LTLProductCatalog } from '@components';
import { useParams } from '@solidjs/router';
import { closeModal, openModal } from '@store/modals';
import { Component } from 'solid-js';

const CustomerProductCatalog: Component = () => {
  const params = useParams();
  return (
    <Stack class="min-h-[400px] h-[calc(100vh-210px)]">
      <LTLProductCatalog
        customerId={Number(params.id)}
        fromCustomerDetails={true}
        closeModal={closeModal}
        openModal={openModal}
        changeTrackingSources={{
          add: CHANGE_TRACKING_SOURCES.customerDetails.productCatalogCreate,
          update: CHANGE_TRACKING_SOURCES.customerDetails.productCatalogUpdate,
          delete: CHANGE_TRACKING_SOURCES.customerDetails.productCatalogDelete,
          import: CHANGE_TRACKING_SOURCES.customerDetails.productCatalogImport,
        }}
      />
    </Stack>
  );
};

export default CustomerProductCatalog;
